import Slider from "./Slider";
import SliderCustom from "./SliderCustom";

export { SliderCustom };
export default Slider;
